export default {
  id: 'dayunshan_109',
  content: `# 大云山苦荞叶的种植
  ![大云山苦荞叶的种植1](https://cdn.keihong.tech/img/20250524103710464.jpg)

![大云山苦荞叶的种植2](https://cdn.keihong.tech/img/20250524103715207.jpg)

![大云山苦荞叶的种植3](https://cdn.keihong.tech/img/20250524103718996.jpg)

![大云山苦荞叶的种植4](https://cdn.keihong.tech/img/20250524103723629.jpg)`
}
